<template>
  <div class="field">
    <transition name="fade">
      <label v-if="title" :title="description || title">
        {{ title }}
        <span class="required">{{ required ? '*' : '' }}</span>
      </label>
    </transition>
    <input
      ref="widget"
      style="width: 100%;"
      type="text"
      :name="name"/>
  </div>
</template>

<script>
  import _ from 'lodash';
  import Vue from 'vue';

  export default {
    props: {
      dataSource: {
        type: Array,
        default: () => [{}]
      },
      label: String,
      name: String,
      description: String,
      placeholder: String,
      required: [Boolean, String],
      listWidth: {
        type: Number
      },
      dataTextField: {
        type: String,
        default: 'text'
      },
      dataValueField: {
        type: String,
        default: 'value'
      },
      template: {
        type: String,
        default: ''
      },
      enable: {
        type: Boolean,
        default: true
      },
      value: {
        type: [Object, Array, String, Number]
      },
      index: {
        type: Number
      }
    },

    data () {
      const value = _.isObject(this.value) && this.hasValue(this.value.value) ? _.isArray(this.value.value) ? this.value.value : [this.value.value] : _.isString(this.value) || _.isNumber(this.value) ? [this.value] : _.isArray(this.value) ? this.value : this.getValueIndex();

      const config = {
        dataTextField: this.dataTextField,
        dataValueField: this.dataValueField,
        dataSource: {
          data: this.dataSource
        },
        enable: this.enable,
        template: this.template,
        value,
        change: this.onChange,
        filter: 'contains'
      };

      if (this.placeholder) {
        config.placeholder = this.placeholder;
      }

      return {
        title: this.label,
        config,
        widget: undefined
      };
    },

    mounted () {
      this.widget = new kendo.ui.MultiSelect(this.$refs.widget, this.config);

      if (this.listWidth) {
        this.widget.list.width(this.listWidth);
      }

      this.onChange({ value: this.widget.value() });
    },

    destroyed () {
      this.widget.destroy();
    },

    methods: {
      getValueIndex () {
        if (String(this.index)) {
          const dataItems = this.widget ? this.widget.dataItems() : this.dataSource;
          const data = dataItems[this.index];
          return data && data[this.dataValueField] ? [data[this.dataValueField]] : [];
        }
        return [];
      },

      formatData () {
        return this.widget.value();
      },

      hasValue (value) {
        return _.isArray(value) ? _.size(value) : !isNaN(Number(value)) ? true : !!value;
      },

      normalize (value) {
        if (!isNaN(Number(value))) {
          return Number(value);
        }

        return _.deburr(value).toUpperCase();
      },

      onChange () {
        const data = this.formatData();
        this.$emit('input', data);
        this.$emit('change', data);
      }
    },

    watch: {
      value (newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          Vue.nextTick(() => {
            this.widget.value(_.isObject(newVal) ? _.isArray(newVal.value) ? newVal.value : _.isArray(newVal) ? newVal : [newVal] : []);
          });
        }
      },

      dataSource (val) {
        if (val && _.size(val)) {
          this.widget.setDataSource(new kendo.data.DataSource({ data: val }));
        }
      },

      label (val) {
        this.title = val;
      },

      dataTextField (val) {
        this.widget.setOptions({ dataTextField: val });
      },

      dataValueField (val) {
        this.widget.setOptions({ dataValueField: val });
      },

      enable (val) {
        this.widget.setOptions({ enable: val });
        this.widget.enable(val);
      }
    }
  };
</script>

<style lang="scss" scoped>
  $helpColor: #ff3860;
  $labelColor: #888;

  .required {
    color: $helpColor;
  }

  // Animations
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
</style>
